<template>
  <div>
    <el-dialog :visible.sync="dialogFormVisible" width="800px" :show-close="false" destroy-on-close class="myPicShowDialogClass" @close="closeVideo" @opened="dialogOpened">
      <div class="video">
        <div id="dplayer" class="video-player" />
        <el-button style="position: absolute; top:0px;right:0px;background-color:transparent;border:none;color:#fff" icon="el-icon-close" circle @click="dialogFormVisible=false" />

      </div>
    </el-dialog>

  </div>
</template>

<script>

import DPlayer from 'dplayer'

export default {
  data() {
    return {
      dialogFormVisible: false,
      playUrl: '',
      videoFormat: '',
      dplayer: null

    }
  },
  methods: {
    playVideo(data) {
      this.dialogFormVisible = true
      this.playUrl = data
    },
    closeVideo() {
      if (this.playUrl) {
        this.dplayer.destroy()
        this.dplayer = null
      }
      this.video = null
    },
    dialogOpened() {
      this.play(this.playUrl)
    },
    play() {
      if (this.dplayer != null) {
        this.dplayer.destroy()
        this.dplayer = null
      }
      this.dplayer = new DPlayer({
        container: document.getElementById('dplayer'),
        autoplay: true,
        loop: true,
        lang: 'zh-cn',
        screenshot: false,
        hotkey: true,
        preload: 'auto',
        mutex: true,
        video: {
          url: this.playUrl
          // type: that.videoFormat
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.myPicShowDialogClass::v-deep .el-dialog__header {
  padding: 0;
}

.myPicShowDialogClass::v-deep .el-dialog__body {
  padding: 0;
}

.video {
  display: flex;
  width: 100%;
  height: 500px;
  position: relative;
  justify-content: center;

  .video-player {
    height: 500px;
    width: 100%;
    background-color: #000;
  }
}
</style>
